import React from 'react';

const ErrorMsg = ({errorMsg,click,style}) => {
    if (!errorMsg) return null;
    const mergedStyle = Object.assign({
        fontSize: '0.83rem',
        color: '#FF0000',
        textAlign: 'left',
        marginBottom: '1.4rem',
        lineHeight: '1.6',
        listStyle: 'none',
        padding: 0
    }, style);

    // 该手机号已注册，如果忘记密码，可<a href="https://www.baidu.com">『重置密码』</a>！
    if(errorMsg&&errorMsg.phone&&errorMsg.phone[0] === '该手机号已注册'){
        return (<div style={mergedStyle}>该手机号已注册，如果忘记密码，可<span style={{cursor:'pointer'}} onClick={click}>『重置密码』</span>！</div>)
    }
    if (typeof(errorMsg) == 'string')
        return (<div style={mergedStyle}>{errorMsg}</div>);
    let arr = [];
    for (let key in errorMsg) {
        arr.push(<li>{errorMsg[key]}</li>)
    }
    return (<ul style={mergedStyle}>{arr}</ul>);
}

export default ErrorMsg;
